import { useEffect, useState } from 'react';
import { useConfirmDialog } from '@/store';

export function ConfirmDialog() {
  const { open, title, message, confirmLabel, onConfirm, cancel } =
    useConfirmDialog();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (open) {
      const frame = requestAnimationFrame(() => setVisible(true));
      return () => cancelAnimationFrame(frame);
    } else {
      setVisible(false);
    }
  }, [open]);

  if (!open && !visible) return null;

  function handleConfirm() {
    onConfirm();
    cancel();
  }

  return (
    <div
      className={`confirm-dialog ${visible && open ? 'confirm-dialog--open' : ''}`}
    >
      <div
        className="confirm-dialog__overlay"
        role="button"
        tabIndex={-1}
        aria-label="Close dialog"
        onClick={cancel}
        onKeyDown={(e) => e.key === 'Escape' && cancel()}
      />
      <div className="confirm-dialog__card">
        <p className="confirm-dialog__title">{title}</p>
        <p className="confirm-dialog__message">{message}</p>
        <div className="confirm-dialog__actions">
          <button className="confirm-dialog__cancel" onClick={cancel}>
            Cancel
          </button>
          <button className="confirm-dialog__confirm" onClick={handleConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
